import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Alert, Card, message, Divider, Input } from "antd";

import { req_edit_lrs_spaceInformation, req_single_people } from "../../api";
import storageUtils from "../../utils/storageUtils";
const { Search } = Input;

class SpaceModalConfirmor extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    space: {},
    peopleB: {},
    peopleC: {},
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_search_item = async (key, type) => {
    // console.log(key);
    const result = await req_single_people(key, storageUtils.getUser().token);
    //console.log(result);
    if (result === null) {
      message.success("查無此人");
    } else {
      type === "B"
        ? this.setState({ peopleB: result })
        : this.setState({ peopleC: result });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  onBSearch = (value) => {
    //console.log(value);
    if (value.length > 4) {
      this.api_search_item(value, "B");
    } else {
    }
  };
  onCSearch = (value) => {
    //console.log(value);
    if (value.length > 4) {
      this.api_search_item(value, "C");
    } else {
    }
  };
  onBChange = () => {
    const { peopleB } = this.state;
    const { Uid } = this.props.space;
    const item = {
      condition: "CONFIRMORB",
      ConfirmorBCode: peopleB.EmployeeId,
      Uid: Uid,
    };
    //console.log(item)
    this.api_modify_item(item);
  };
  onCChange = () => {
    const { peopleC } = this.state;
    const { Uid } = this.props.space;
    const item = {
      condition: "CONFIRMORC",
      ConfirmorCCode: peopleC.EmployeeId,
      Uid: Uid,
    };
    //console.log(item)
    this.api_modify_item(item);
  };
  ////////////////////////////////////////////////////////////

  render() {
    const {
      ConfirmorBCode,
      ConfirmorBTwName,
      ConfirmorCCode,
      ConfirmorCTwName,
      RoomCode,
      RoomTwName,
      MustConfirmLevel,
    } = this.props.space;
    const { peopleB, peopleC } = this.state;
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        {MustConfirmLevel === "A" ? (
          <>
            <Divider />
            <div style={{ fontSize: "1.3em", color: "red" }}>僅承辦人審查</div>
          </>
        ) : (
          <>
            <div className="row">
              <Divider />
              <div style={{ fontSize: "1.3em" }}>
                二審人員：
                {ConfirmorBTwName === "NONE" ? "未配置" : ConfirmorBTwName}(
                {ConfirmorBCode === "NONE" ? "待定" : ConfirmorBCode})
              </div>{" "}
              <Search
                placeholder="接任者職號"
                allowClear
                enterButton={
                  <>
                    <i className="fas fa-search"></i> 查詢
                  </>
                }
                size="large"
                onSearch={this.onBSearch}
              />
              {JSON.stringify(peopleB) === "{}" ? (
                ""
              ) : (
                <div style={{ paddingTop: "2px", width: "100%" }}>
                  <Search
                    placeholder="接任者職號"
                    allowClear
                    enterButton={
                      <>
                        <i className="fas fa-exchange-alt"></i> 接任
                      </>
                    }
                    size="large"
                    value={peopleB.TwName}
                    onSearch={this.onBChange}
                  />
                </div>
              )}
              <></>
            </div>
            {MustConfirmLevel === "C" ? (
              <div className="row">
                <Divider />
                <div style={{ fontSize: "1.3em" }}>
                  三審人員：
                  {ConfirmorCTwName === "NONE" ? "未配置" : ConfirmorCTwName}(
                  {ConfirmorCCode === "NONE" ? "待定" : ConfirmorCCode})
                </div>{" "}
                <Search
                  placeholder="接任者職號"
                  allowClear
                  enterButton={
                    <>
                      <i className="fas fa-search"></i> 查詢
                    </>
                  }
                  size="large"
                  onSearch={this.onCSearch}
                />
                {JSON.stringify(peopleC) === "{}" ? (
                  ""
                ) : (
                  <div style={{ paddingTop: "2px", width: "100%" }}>
                    <Search
                      placeholder="接任者職號"
                      allowClear
                      enterButton={
                        <>
                          <i className="fas fa-exchange-alt"></i> 接任
                        </>
                      }
                      size="large"
                      value={peopleC.TwName}
                      onSearch={this.onCChange}
                    />
                  </div>
                )}
                <></>
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalConfirmor);
